import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { dishUpdate } from '../../../store/Dish/api';

export const useEditDish = () => {
    const { t } = useTranslation()
    const queryClient = useQueryClient();
    const history = useHistory();
    const { catId, dishId } = useParams();

    return useMutation(['editCurrentDish'], ({ dish, photo, archived = 0 }) => dishUpdate(dish, photo, archived), {
        onSuccess: async (_, { archived }) => {
            await queryClient.invalidateQueries(['menu-categories']);
            await queryClient.invalidateQueries(['menu-category-dish', dishId]);
            await queryClient.invalidateQueries(['dish-languages', dishId]);
            if(archived === "1") {
                history.push(`/chain/menu/${catId}/items`);
            }
            toast.success(t('Dish successfully edited'));
        },
        onError: (e) => {
            toast.error(e.response?.data?.message)
        },
    });
};
